import React from "react";
import styles from "./DownloadButton.scss";
import { ShoppingCartParsed } from "../../../../models";
import { Button } from "../../../../components/Button/Button";

export interface IDownloadButtonProps {
  cart: ShoppingCartParsed;
  onInvoiceDownload: (cart: ShoppingCartParsed) => void;
}

const DownloadButton = (props: IDownloadButtonProps): JSX.Element => {
  const { cart, onInvoiceDownload } = props;

  return (
    <Button
      type="primary"
      className={styles.button}
      onClick={() => onInvoiceDownload(cart)}
    >
      <span className={styles.text}>{"Preuzmi PDF"}</span>
    </Button>
  );
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/containers/FinancePage/FinanceList/DownloadButton/index.tsx